/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import { CommonIconsInterface } from "../interface";

const DeleteIcon = ({
  size = "small",
  color = "currentColor",
  className,
}: CommonIconsInterface) => {
  let iconSizeClassName;
  if (size === "small") {
    iconSizeClassName = "w-5 h-5";
  } else {
    iconSizeClassName = "w-7 h-7";
  }

  return (
    <svg
      className={cn(iconSizeClassName, className)}
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      test-id="LagfOwTM"
    >
      <path
        d="M6.9987 22.1667C6.9987 23.45 8.0487 24.5 9.33203 24.5H18.6654C19.9487 24.5 20.9987 23.45 20.9987 22.1667V8.16667H6.9987V22.1667ZM9.33203 10.5H18.6654V22.1667H9.33203V10.5ZM18.082 4.66667L16.9154 3.5H11.082L9.91537 4.66667H5.83203V7H22.1654V4.66667H18.082Z"
        fill={color}
        test-id="ikLe6wv5"
      />
    </svg>
  );
};

export default DeleteIcon;
